import React, { Fragment, useContext, useEffect, useState } from "react";

import downloadImg from "../../../assets/images/whiteDownload.png";
import mcqImg from "../../../assets/images/MCQ.svg";

import { useLocation, useNavigate } from "react-router-dom";
import AppContext from "../../context/AppContext";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScroll from "../../services/InfiniteScroll";
import tinycolor from "tinycolor2"; // Ensure you have tinycolor2 installed

import { courseList, getCompletionsList, getCompletionsExport, setClearCourseData } from "../../_slice/courseCompletionSlice";
import CustomModal from "../../widgets/CustomModal";

function CourseCompletions() {

    const [downloadModal, setDownloadModal] = useState({
        show: false,
        id: "",
        published: "",
    });
    const [showDetails, setShowDetails] = useState({});
    const [checkedState, setCheckedState] = useState({});

    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    // Initialize state to store colors for each course
    const [colors, setColors] = useState([]);

    // Other hook initializations
    const { setLoader } = useContext(AppContext);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    // console.log('location.state', location.state);

    const locationId = location?.state?.orglocation?.locationId || "";
    // const locationType = location?.orglocation?.locationType || "";

    // Get From Local Storage
    const locationType = sessionStorage.getItem("locationType") || "";
    // console.log("locationType", locationType);

    const [modalShow, setModalShow] = useState({ show: false });

    // Redux selector
    const {
        courseData,
        status: courseStatus,
        courseFixtureData,
    } = useSelector((state) => state.course);
    // console.log('courseData', courseData);

    useEffect(() => {
        if (courseStatus === "idle" || locationId) {
            // dispatch(courseList({ setLoader, locationId }));
            fetchMoreCourses(0);
        }
    }, [locationId, navigate, dispatch, setLoader]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const yyyy = date.getFullYear();
        const hh = String(date.getHours()).padStart(2, "0");
        const min = String(date.getMinutes()).padStart(2, "0");

        return `${mm}/${dd}/${yyyy} @ ${hh}:${min}`;
    };

    // Function to fetch more location
    const fetchMoreCourses = (resetPage) => {
        const pageCount = resetPage > 0 ? resetPage : page;
        dispatch(setClearCourseData());

        dispatch(courseList({ locationId, pageCount, navigate, setLoader }))
            .then((response) => {
                // console.log('Api response', response);
                if (response?.payload?.data?.courses?.data?.length > 0) {
                    setPage(response?.payload?.data?.courses?.current_page + 1);
                    setHasMore(
                        response?.payload?.data?.courses?.current_page <
                        response?.payload?.data?.courses?.last_page
                    );
                } else {
                    setHasMore(false);
                }
            })
            .catch((error) => {
                console.error("Error fetching more quests:", error);
            });
    };

    const [completionList, setCompletionList] = useState([]);

    const fetchCompletions = (id, resetPage = 1) => {
        const pageCount = resetPage;
        dispatch(getCompletionsList({ id, navigate }))
            .then((response) => {
                // console.log('response', response);
                const data = response?.payload?.courseCompletions?.data;
                // console.log('data', data);
                if (Array.isArray(data) && data.length > 0) {
                    setCompletionList(data);
                } else {
                    setCompletionList([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching course completions:", error);
            });
    };

    const handleCheckboxChange = (event, id, name) => {
        const checked = event.target.checked;
        setCheckedState({ [id]: checked });
        setShowDetails({ [id]: checked });

        const {
            campus = { campId: "", campName: "" },
            orglocation = { locationId: "", locationName: "" },
            assembly = { assemblyId: "", assemblyName: "" },
            orgId = "",
        } = location?.state || {};

        const newState = {
            campus,
            orglocation,
            assembly,
            course: {
                courseId: checked ? id : "",
                courseName: checked ? name : "",
            },
            orgId,
        };

        if (checked) {
            // console.log("check", id);
            fetchCompletions(id); // ✅ correct usage
        }

        navigate(".", { replace: true, state: newState });
    };

    const exportCourse = async (id) => {
        try {
            const response = await dispatch(getCompletionsExport({ id, navigate })).unwrap();
            if (!response?.url) throw new Error("No download URL received.");

            const link = document.createElement("a");
            link.href = response.url;
            link.download = `quest_completions_${id}.xlsx`;
            document.body.appendChild(link);
            link.click();

            // Delay cleanup to ensure download starts
            setTimeout(() => {
                document.body.removeChild(link);
                URL.revokeObjectURL(response.url); // Free memory
            }, 200); // Increased delay for slower systems
        } catch (error) {
            console.error("Download failed:", error);
            alert(`Export failed: ${error.message}`);
        }
    };

    useEffect(() => {
        if (courseData?.data) {
            const newColors = courseData.data.map((courseTable) => {
                const myColor = courseTable.color?.startsWith("#")
                    ? courseTable.color
                    : `#${courseTable.color}`;
                return {
                    main: myColor,
                    light: tinycolor(myColor).lighten(40).toString(),
                    lighten: tinycolor(myColor).lighten(100).toString(),
                    bright: tinycolor(myColor).brighten(15).toString(),
                    brighter: tinycolor(myColor).brighten(30).toString(),
                    dark: tinycolor(myColor).darken(15).toString(),
                    darker: tinycolor(myColor).darken(30).toString(),
                };
            });
            setColors(newColors);
        }
    }, [courseData?.data]);

    const getContrastColor = (hexColor) => {
        if (!hexColor) return "#000000"; // Fallback color if hexColor is undefined
        let color = hexColor.startsWith("#") ? hexColor : `#${hexColor}`; // Add # if missing
        if (color.length !== 7) return "#000000"; // Invalid color fallback

        const r = parseInt(color.substring(1, 3), 16);
        const g = parseInt(color.substring(3, 5), 16);
        const b = parseInt(color.substring(5, 7), 16);

        const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
        return luminance > 150 ? "#000000" : "#ffffff";
    };

    return (
        <>
            <div className="org">
                <div className="org_header d-flex align-items-center justify-content-between">
                    <h1 className="org_header_heading">Quest Completions</h1>
                </div>
                <InfiniteScroll
                    fetchMoreData={() => fetchCompletions(0)}
                    hasMore={hasMore}
                    isLoading={courseStatus === "loading"}
                    threshold={200}
                >
                    {courseData?.data?.map((courseTable, tableIndex) => {
                        const color = colors[tableIndex] || { main: "#ffffff" }; // Default to white if color is not found
                        const textColor = getContrastColor(color.main);

                        return (
                            <Fragment key={courseTable.id}>
                                <div className="org_table table-border-0 table-responsive">
                                    <table className="table position-relative">
                                        <thead>
                                            <tr>
                                                <td
                                                    style={{
                                                        backgroundColor: color.main,
                                                        color: textColor,
                                                    }}
                                                    className="org_table_column w-5"
                                                >
                                                </td>
                                                <td
                                                    style={{
                                                        backgroundColor: color.main,
                                                        color: textColor,
                                                    }}
                                                    className="org_table_column w-15"
                                                >
                                                    Quest Area's Marker Name
                                                </td>
                                                <td
                                                    style={{
                                                        backgroundColor: color.main,
                                                        color: textColor,
                                                    }}
                                                    className="org_table_column w-35 text-center"
                                                >
                                                    Action
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {courseTable?.courses?.map((course, courseIndex) => {
                                                return (
                                                    <Fragment key={course.id}>
                                                        <tr key={course.id}>
                                                            <td
                                                                style={{ backgroundColor: color.light }}
                                                                className="org_table_row w-5"
                                                            >
                                                                <label
                                                                    className="check_box ml-2"
                                                                    htmlFor={`checkbox-${course.id}`}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`checkbox-${course.id}`}
                                                                        checked={checkedState[course.id] || false}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange(
                                                                                e,
                                                                                course.id,
                                                                                course.name
                                                                            )
                                                                        }
                                                                    />
                                                                    <span
                                                                        style={{
                                                                            backgroundColor: checkedState[course.id] ? color.main : "",
                                                                            border: checkedState[course.id] ? `2px solid ${color.main}` : "",
                                                                        }}
                                                                        className="checkbox_check_course"
                                                                    ></span>
                                                                    {/* <span className="checkbox_check"></span> */}
                                                                </label>
                                                            </td>
                                                            <td
                                                                style={{ backgroundColor: color.light }}
                                                                className="org_table_row w-15"
                                                            >
                                                                {course?.starting_marker}
                                                            </td>
                                                            <td
                                                                style={{ backgroundColor: color.light }}
                                                                className="org_table_row w-30"
                                                            >
                                                                <div
                                                                    className="d-flex flex-wrap align-items-center justify-content-center"
                                                                    style={{ gap: "10px" }}
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        style={{ backgroundColor: color.darker }}
                                                                        className={`action_new_btn mr-2`}
                                                                        title="Download"
                                                                        onClick={() =>
                                                                            exportCourse(course.id)
                                                                        }
                                                                    >
                                                                        <img src={downloadImg} alt="" className="" />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        {showDetails[course.id] && (
                                                            <tr key={`details-${course.id}`}>
                                                                <td colSpan={12} className="pt-0 pl-0 pb-0">
                                                                    <div
                                                                        className={`table-responsive fixturePaddingCustom ${completionList?.length > 5
                                                                            ? "fixtureTableInn"
                                                                            : "heightauto"
                                                                            }`}
                                                                    >
                                                                        <table className="w-100">
                                                                            <thead>
                                                                                <tr>
                                                                                    <td
                                                                                        style={{
                                                                                            backgroundColor: color.main,
                                                                                            color: textColor,
                                                                                        }}
                                                                                        className="org_table_column w-20"
                                                                                    >
                                                                                        Full Name
                                                                                    </td>
                                                                                    <td
                                                                                        style={{
                                                                                            backgroundColor: color.main,
                                                                                            color: textColor,
                                                                                        }}
                                                                                        className="org_table_column w-20"
                                                                                    >
                                                                                        Email
                                                                                    </td>
                                                                                    <td
                                                                                        style={{
                                                                                            backgroundColor: color.main,
                                                                                            color: textColor,
                                                                                        }}
                                                                                        className="org_table_column w-20"
                                                                                    >
                                                                                        Completion Date & Time
                                                                                    </td>
                                                                                    <td
                                                                                        style={{
                                                                                            backgroundColor: color.main,
                                                                                            color: textColor,
                                                                                        }}
                                                                                        className="org_table_column w-20"
                                                                                    >
                                                                                        Total Quest
                                                                                        <br></br>
                                                                                        Time (minutes)
                                                                                    </td>
                                                                                    <td
                                                                                        style={{
                                                                                            backgroundColor: color.main,
                                                                                            color: textColor,
                                                                                        }}
                                                                                        className="org_table_column w-20"
                                                                                    >
                                                                                        MCQ
                                                                                        <br></br>
                                                                                        Pass/Fail
                                                                                    </td>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {completionList && completionList.length > 0 ? (
                                                                                    completionList.map((data) => (
                                                                                        <tr key={data.id}>
                                                                                            <td
                                                                                                style={{ backgroundColor: color.light }}
                                                                                                className="org_table_row_nested w-20"
                                                                                            >
                                                                                                {data?.name}
                                                                                            </td>
                                                                                            <td
                                                                                                style={{ backgroundColor: color.light }}
                                                                                                className="org_table_row_nested w-20"
                                                                                            >
                                                                                                {data?.email}
                                                                                            </td>
                                                                                            <td
                                                                                                style={{ backgroundColor: color.light }}
                                                                                                className="org_table_row_nested w-20"
                                                                                            >
                                                                                                {/* {data?.completion_datetime} */}
                                                                                                {data?.completion_datetime ? formatDate(data.completion_datetime) : ""}
                                                                                            </td>
                                                                                            <td
                                                                                                style={{ backgroundColor: color.light }}
                                                                                                className="org_table_row_nested w-20"
                                                                                            >
                                                                                                {data?.time}
                                                                                            </td>
                                                                                            <td
                                                                                                style={{ backgroundColor: color.light }}
                                                                                                className="org_table_row_nested w-20"
                                                                                            >
                                                                                                <button
                                                                                                    type="button"
                                                                                                    // style={{ backgroundColor: "transparent" }}
                                                                                                    style={{ backgroundColor: color.darker }}
                                                                                                    className={`action_new_btn mr-2`}
                                                                                                    title="Fixture"
                                                                                                    onClick={() =>
                                                                                                        setModalShow({ show: true, mcq: data?.data?.mcq || [] })
                                                                                                    }
                                                                                                >
                                                                                                    <img src={mcqImg} alt="" srcset="" />
                                                                                                </button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))
                                                                                ) : (
                                                                                    <tr>
                                                                                        <td
                                                                                            colSpan={4}
                                                                                            style={{ backgroundColor: color.light }}
                                                                                        >
                                                                                            No data available
                                                                                        </td>
                                                                                    </tr>
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </Fragment>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </Fragment>
                        );
                    })}
                </InfiniteScroll>
            </div>

            {/* Fixture */}
            <CustomModal
                show={modalShow.show}
                onHide={() => setModalShow({ show: false })}
                heading={"MCQ [Pass/Fail]"}
                size="md"
                body={
                    <form>
                        <div className="row">
                            <table className="custom-table w-100">
                                <thead>
                                    <tr>
                                        <td className="text-left">Fixture Name</td>
                                        <td className="text-left">Pass/Fail</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {modalShow.mcq?.length > 0 ? (
                                        modalShow.mcq.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-left">{item.fixture_name}</td>
                                                <td className="text-left">{item.pass ? "Pass" : "Fail"}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="2" className="text-center">No data available</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </form>
                }
            />

        </>
    );
}

export default CourseCompletions;